import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { DropDownItem, IntDropDownItem, SimpleResponse } from '../../../models/generic-response.model';
import { Membership, MemContactListDropDown, MemSubscription, REF_MemBillingMethod, REF_SubscriptionStatus } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';

@Component({
    selector: 'app-mem-subscription',
    templateUrl: './mem-subscription.component.html',
    styleUrls: ['./mem-subscription.component.css']
})
/** mem-subscription component*/
export class MemSubscriptionComponent {
    /** mem-subscription ctor */
    encryptedUser: string = ''
    memSubscriptionForm: FormGroup;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    sites: CMSite[];
    selectedSiteIDs = [];
    memSubscription: MemSubscription = <MemSubscription>{};
    ref_SubscriptionStatus_List: REF_SubscriptionStatus[];
    ref_MemBillingMethod_List: REF_MemBillingMethod[];
    subscriptionID: number = 0;
    memContact_dd: MemContactListDropDown[];
    memberShip: Membership;
    contactId: number;
    private destroy$ = new Subject<void>();

    constructor(
        private _membershipService: MembershipService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private _datePipe: DatePipe,
        private fb: FormBuilder,
        private _route: ActivatedRoute,
        private _clubService: CMClubService) {
        this._localService.setShowMenu(true);
        this._localService.setIsContract(false);
        this._localService.setIsMembership(true);
        this._localService.setRouteName("mem-subscription");
    }


    ngOnInit() {
         this.memSubscriptionForm = this.prepareMemSubscriptionForm();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    prepareMemSubscriptionForm(): FormGroup<any> {
        return this.fb.group({
            vPaymentMethodID: [''],
            paused: ['0'],
            status: [0],
            baseAmount: ['0'],
            subscription: [''],
            vSubscriptionId: [''],
            totalAmount: ['0'],
            taxAmount: ['0'],
            surchargeAmount: ['0'],
            coupon: [''],
            paymentType: [0],
            billingDay: ['0'],
            dtNextBill: [''],
            errorMessage: [''],
            createdByID: ['0'],
            dtCreated: [''],
            dateEnded: [''],
            modifiedByID: ['0'],
            dtModified: [''],
            contactId: [0]
        })
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.subscriptionID = this._route.snapshot.queryParams.subscriptionID ? this._route.snapshot.queryParams.subscriptionID : 0;
                    this.contactId = this._route.snapshot.queryParams.contactId ? +this._route.snapshot.queryParams.contactId : 0;
                    if (this.subscriptionID > 0 || this.contactId > 0) {
                        this.memSubscription_Get();
                        this.membership_GetByContactID(this.contactId);
                    }
                   
                    this.loadData();
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.memContactDDget();
                    this.ref_SubscriptionStatus_List = this._localService.refMem_GetAllResponse.ref_SubscriptionStatus_List;
                    this.ref_MemBillingMethod_List = this._localService.refMem_GetAllResponse.ref_MemBillingMethod_List;

                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.memContactDDget();
                    this.ref_SubscriptionStatus_List = this._localService.refMem_GetAllResponse.ref_SubscriptionStatus_List;
                    this.ref_MemBillingMethod_List = this._localService.refMem_GetAllResponse.ref_MemBillingMethod_List;
                }
            }
        })
    }


    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this._clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this._clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                        this.sites.unshift({
                            siteID: 0,
                            clubID: 0,
                            class1Code: 0,
                            clpcompanyID: 0,
                            siteName: "--Select--",
                            teamCode: 0,
                            address: "",
                            city: "",
                            state: "",
                            country: "",
                            zip: "",
                            taxRate: 0,
                            scheduleSiteVisitURL: "",
                            scheduleOpenHouseURL: "",
                            vesselsURL: "",
                            kioskURL: "",
                            lnkCustom1URL: "",
                            lnkCustom2URL: "",
                            lnkCustom3URL: "",
                            lnkCustom4URL: "",
                            lnkCustom5URL: "",
                            mktCustomText1: "",
                            mktCustomText2: "",
                            mktCustomText3: "",
                            mktCustomText4: "",
                            mktCustomText5: "",
                            mktMultiText1: "",
                            mktMultiText2: "",
                            mktMultiText3: "",
                            mktMultiText4: "",
                            mktMultiText5: "",
                            engDashCustomMMT1D1: "",
                            engDashCustomMMT1D2: "",
                            engDashCustomMMT1D3: "",
                            engDashCustomMMT1D4: "",
                            engDashCustomMMT1D5: "",
                            engDashCustomMMT1D6: "",
                            engDashCustomMMT1D7: "",
                            engDashCustomMMT1D8: "",
                            engDashCustomMMT1D9: "",
                            engDashCustomMMT1D10: "",
                            dtCreated: "",
                            dtModified: "",
                            newLead: 0,
                            newMember: 0,
                            contractSent: 0,
                            contractOpen: 0,
                            waitingCountersign: 0,
                            memberAdded: 0,
                            contractUpgraded: 0,
                            contractRenewed: 0,
                            memberTerminated: 0,
                            contractExpiration: 0,
                            contactUpdate: 0,
                            referralRequest: 0,
                            teamCodeDisplay: "",
                            class1Display: "",
                            phLocation: "",
                            custom1: '',
                            custom2: '',
                            custom3: '',
                            contractCounts: 0
                        })
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async memSubscription_Update() {
        console.log(this.memberShip)
        let memID = this.memContact_dd.filter(x => x.id == +this.memSubscriptionForm.controls.contactId.value ? +this.memSubscriptionForm.controls.contactId.value : this.contactId)[0]?.id2;
        this.memSubscription.subscriptionID = this.subscriptionID > 0 ? this.subscriptionID : this.memSubscription?.subscriptionID;
        this.memSubscription.membershipIID = +this.memberShip.incrementalID;
        this.memSubscription.cmMemberID = memID ? memID : 0;
        this.memSubscription.contactID = +this.memSubscriptionForm.controls.contactId.value;
        this.memSubscription.contractID = +this.memberShip.contractID;
        this.memSubscription.paymentType = +this.memSubscriptionForm.controls.paymentType.value;
        this.memSubscription.vPaymentMethodID = this.memSubscriptionForm.controls.vPaymentMethodID.value;
        this.memSubscription.baseAmount = +this.memSubscriptionForm.controls.baseAmount.value;
        this.memSubscription.paused = this.memSubscriptionForm.controls.paused.value;
        this.memSubscription.status = +this.memSubscriptionForm.controls.status.value;
        this.memSubscription.coupon = this.memSubscriptionForm.controls.coupon.value;
        this.memSubscription.billingDay = this.memSubscriptionForm.controls.billingDay.value;
        this.memSubscription.dtNextBill = this._datePipe.transform(this.memSubscriptionForm.controls.dtNextBill.value, 'MM/dd/yyyy');
        this.memSubscription.errorMessage = this.memSubscriptionForm.controls.errorMessage.value;
        this.memSubscription.createdByID = 1;
        this.memSubscription.dtCreated = new Date().toISOString();
        this.memSubscription.modifiedByID = 1
        this.memSubscription.dtModified = new Date().toISOString();
        await this._membershipService.memSubscription_Update(this.encryptedUser, this.memSubscription)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        Swal.fire({ icon: "success", title: "", html: 'Successfully update a list.' });
                        return;
                    }
                    else {
                        Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                        return;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memSubscription_Create() {
        let memSubscription: MemSubscription = <MemSubscription>{};
        memSubscription.subscriptionID = 0;
        memSubscription.membershipIID = +this.memberShip.incrementalID;
        memSubscription.cmMemberID = this.memContact_dd.filter(x => x.id == +this.memSubscriptionForm.controls.contactId.value)[0].id2;
        memSubscription.contactID = +this.memSubscriptionForm.controls.contactId.value;
        memSubscription.contractID = this.memberShip.contractID;
        memSubscription.paymentType = +this.memSubscriptionForm.controls.paymentType.value;
        memSubscription.vPaymentMethodID = this.memSubscriptionForm.controls.vPaymentMethodID.value;
        memSubscription.baseAmount = +this.memSubscriptionForm.controls.baseAmount.value;
        memSubscription.paused = this.memSubscriptionForm.controls.paused.value;
        memSubscription.status = +this.memSubscriptionForm.controls.status.value;
        memSubscription.coupon = this.memSubscriptionForm.controls.coupon.value;
        memSubscription.billingDay = this.memSubscriptionForm.controls.billingDay.value;
        memSubscription.dtNextBill = this._datePipe.transform(this.memSubscriptionForm.controls.dtNextBill.value, 'MM/dd/yyyy');
        memSubscription.errorMessage = this.memSubscriptionForm.controls.errorMessage.value;
        memSubscription.createdByID = 1;
        memSubscription.dtCreated = new Date().toISOString();
        memSubscription.modifiedByID = 1
        memSubscription.dtModified = new Date().toISOString();
        await this._membershipService.memSubscription_Create(this.encryptedUser, memSubscription)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.subscriptionID = response?.messageInt;
                    if (response?.messageBool) {
                        this._router.navigate(['/mem-subscription'], { queryParams: { subscriptionID: this.subscriptionID } });
                        Swal.fire({ icon: "success", title: "", html: 'Successfully Create!' });
                        return;
                    }
                    else {
                        Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                        return;
                    }

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async subscription_Delete() {
        Swal.fire({
            title: '',
            text: "Are you sure, You wants to delete?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this._membershipService.subscription_Delete(this.encryptedUser, this.subscriptionID)
                    .then(async (result: SimpleResponse) => {
                        if (result) {
                            let response = UtilityService.clone(result);
                            if (response?.messageBool) {
                                this._router.navigate(['/mem-subscription-list'])
                            }
                            else {

                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._globalService.error("contact-task.getLoadUsers", err.message, null,
                        );
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });
    }

    async memSubscription_Get() {
        await this._membershipService.memSubscription_Get(this.encryptedUser, this.subscriptionID, this.contactId)
            .then(async (result: MemSubscription) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memSubscription = response;
                    this.patchSubscriptionForm();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchSubscriptionForm() {
        this.memSubscriptionForm.controls.vPaymentMethodID.setValue(this.memSubscription.vPaymentMethodID);
        this.memSubscriptionForm.controls.paused.setValue(this.memSubscription.paused);
        this.memSubscriptionForm.controls.status.setValue(this.memSubscription.status);
        this.memSubscriptionForm.controls.baseAmount.setValue(this.memSubscription.baseAmount);
        this.memSubscriptionForm.controls.coupon.setValue(this.memSubscription.coupon);
        this.memSubscriptionForm.controls.billingDay.setValue(this.memSubscription.billingDay);
        this.memSubscriptionForm.controls.errorMessage.setValue(this.memSubscription.errorMessage);
        this.memSubscriptionForm.controls.createdByID.setValue(this.memSubscription.createdByID);
        this.memSubscriptionForm.controls.paymentType.setValue(this.memSubscription.paymentType);
        this.memSubscriptionForm.controls.contactId.setValue(this.memSubscription.contactID);
        this.memSubscriptionForm.controls.dtNextBill.setValue(this.memSubscription.dtNextBill);

        this.memSubscriptionForm.controls.subscription.setValue(this.memSubscription.subscription);
        this.memSubscriptionForm.controls.vSubscriptionId.setValue(this.memSubscription.vSubscriptionID);
        this.memSubscriptionForm.controls.totalAmount.setValue(this.memSubscription.totalAmount);
        this.memSubscriptionForm.controls.taxAmount.setValue(this.memSubscription.taxAmount);
        this.memSubscriptionForm.controls.surchargeAmount.setValue(this.memSubscription.surchargeAmount);
    }

    async memContactDDget() {
        await this._membershipService.memContact_CMMember_GetList_DD(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID, this.clubConfig?.clubId)
            .then(async (result: MemContactListDropDown[]) => {
                if (result) {
                    this.memContact_dd = UtilityService.clone(result);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.memContactDDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async onChangeMemContact() {
        await this.membership_GetByContactID(+this.memSubscriptionForm.controls.contactId.value);
    }

    async membership_GetByContactID(contactID) {
        await this._membershipService.membership_GetByContactID(this.encryptedUser, contactID)
            .then(async (result: Membership) => {
                if (result) {
                    this.memberShip = <Membership>{};
                    this.memberShip = UtilityService.clone(result);
                    if (isNullOrUndefined(this.memberShip)) {
                        Swal.fire({ icon: "error", title: "", html: 'The Contact is Not Subcribe!' });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.membership_GetByContactID_DDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }
}
